import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { NgIf } from '@angular/common';
import { MatIconButton } from '@angular/material/button';

import { ErrorService } from '../../services/error.service';

@Component({
	selector: 'copo-submission-feedback',
	templateUrl: './submission-feedback.component.html',
	styleUrl: './submission-feedback.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, MatRippleModule, MatIconModule, TranslateModule, MatIconButton]
})
export class SubmissionFeedbackComponent implements OnDestroy {
	errorMessage: unknown;
	errorTitle: unknown;
	errorSubscription?: Subscription;
	constructor(
		private readonly errorService: ErrorService,
	) {
		this.errorSubscription = this.errorService.errMsgObs.subscribe(error => {
			this.errorMessage = error.message;
			this.errorTitle = error.title;
		});
	}

	ngOnDestroy() {
		if (this.errorSubscription !== undefined) {
			this.errorSubscription.unsubscribe();
		}
	}

	evtCancel() {
		this.errorMessage = '';
		this.errorTitle = '';
	}
}
